import { CSSProperties, ReactElement } from 'react'

import classNames from 'classnames'

import { Icon } from 'components/core'
import { asinUrl } from 'routing/urls'
import { CountryCode } from 'types'

import * as styles from './styles.scss'

type AsinLinkColor = 'default' | 'muted' | 'inherit'

interface Props {
    asin: string
    countryCode: CountryCode
    showAmazonIcon?: boolean
    color?: AsinLinkColor
    className?: string
    style?: CSSProperties
}

function AsinLink({
    asin,
    countryCode,
    showAmazonIcon = true,
    color = 'default',
    className = '',
    style = {},
}: Props): ReactElement | null {
    return asin ? (
        <a
            href={asinUrl(asin, countryCode)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={classNames(
                styles.asinLink,
                {
                    [styles['color-default']]: color === 'default',
                    [styles['color-muted']]: color === 'muted',
                    [styles['color-inherit']]: color === 'inherit',
                },
                className
            )}
            style={{ ...style }}
        >
            {asin}
            {showAmazonIcon && (
                <Icon name="AMAZON" size={12} margin="0 0 0 4px" />
            )}
        </a>
    ) : null
}

export default AsinLink
